<a [attr.href]="to ? to : null" [target]="template === 'external' ? '_blank' : '_self'">
  <div class="base-card -title-container">
    <icon *ngIf="icon" [icon]="icon" [class]="iconsize + ' ' + iconcolor"></icon>
    <h3 class="mt-0">{{title}}</h3>
  </div>
  <ng-content></ng-content>
</a>